import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { CurrencyValue } from '../../../common/currencyValue';
import PaymentFlowContainer from '../PaymentFlowContainer';
import { NotificationManager } from 'react-notifications';

export function DirectTransfer({ match }) {
    const { t } = useTranslation();
    const history = useHistory();

    const cartID = useSelector(state => state.tenant.cartID);
    const firstPayments = useSelector(state => state.tenant.firstPayment);
    const firstPaymentTotal = useMemo(
        () => (firstPayments.debts || 0) + (firstPayments.onGoing || 0) + Object.values(firstPayments.oneTime).reduce((acc, v) => acc + v, 0),
        [firstPayments]
    );
    const currency = useSelector(state => state.tenant.buildingCurrency);

    const copyToClipboard = () => {
        const cartIdText = document.getElementById('cartID').innerText;
        if (cartIdText) {
          navigator.clipboard.writeText(cartIdText)
            .then(() => {
              NotificationManager.success(t('payments.copied'))
            })
            .catch(err => {
              console.log('Something went wrong', err);
            })
        }
    }


    return (
        <PaymentFlowContainer title={t('payments.payment_for')} subheader={t('payments.directTransferPayment')}>

            <div className='amount-to-transfer'>
                <span>{t('payments.amountToTransfer')}:</span>
                <CurrencyValue currency={currency}>{firstPaymentTotal}</CurrencyValue>
            </div>

            <div className='direct-transfer'>
                <div className='credit-card-and-actions-block managers transfer'>
                    <div className='verification-code'>
                        {t('payments.verificationCode')}                    
                        <div className='verification-note'>{t('payments.transferNote')}</div>
                    </div>

                    <div className='cart-id-wrapper' onClick={copyToClipboard}>
                        <div id="cartID">{cartID}</div>
                        <div className='copy' id="copy-btn">{t('payments.copyCode')}</div>
                    </div>

                    <div className='confirmation-sent'>{t('payments.paymentConfirmationWillBeSent')}</div>
                </div>

                <div className='credit-card-and-actions-block managers account'>
                    <div className='details-title'>{t('payments.bankAccountDetails')}</div>
                    <div>{t('expenses.bank')} - מזרחי בנק (20)</div>
                    <div>{t('expenses.branch')} - 494</div>
                    <div>{t('reports.account')} - 314594</div>
                    <div>{t('payments.byOrderBllink')}</div>
                </div>
            </div>
        </PaymentFlowContainer>
    )
}
